import PortalIdParser from 'PortalIdParser';
import noAuthHttp from '../../http/noAuthApiClient';
// @ts-ignore Untyped import
import authHttp from '../../http/apiClient';
import { getSpamProtectionResponse } from '../../utils/getSpamProtectionResponse';
import { isInPreview as getIsInPreview } from '../../utils/isInPreview';
export async function createVisitorThread({
  sessionId,
  messageId,
  hubspotUtk,
  messagesPageUri,
  visitorThreadInitialHistory,
  zoneId,
  entryUrlMetadata,
  widgetData
}) {
  const isInPreview = getIsInPreview();
  const url = isInPreview ? `livechat/v1/thread/visitor/preview/create` : `livechat-public/v1/thread/visitor/create`;
  const spamProtectionResponse = await getSpamProtectionResponse(widgetData);
  const data = {
    visitorMessage: visitorThreadInitialHistory[visitorThreadInitialHistory.length - 1],
    expectedInitialHistory: visitorThreadInitialHistory.slice(0, -1).map(message => message.richText || message.text),
    entryUrlMetadata,
    spamProtectionResponse
  };
  const client = isInPreview ? authHttp : noAuthHttp;
  return client.post(url, {
    query: {
      sessionId,
      welcomeMessageId: messageId,
      hubspotUtk,
      portalId: PortalIdParser.get(),
      expectedResponseType: 'WRAPPER_V2',
      zoneId
    },
    data,
    headers: {
      'X-HubSpot-Messages-Uri': messagesPageUri
    }
  });
}